module.exports = __webpack_public_path__ + "img/beaver_transport2.cfd6b800.png";